module.exports = __webpack_public_path__ + "img/Cross in circle.447a6ea.png";